<template>
    <div
        v-if="items && model"
        class="product-filter-checkboxes"
    >
        <ProductsFilterTitle
            :name="items.name"
            :count="selectedCount"
        ></ProductsFilterTitle>
        <div>
            <ul
                class="color-swatches list-style-none pa-0 ma-0"
            >
                <template
                    v-for="attrObj in items.values"
                    :key="attrObj.uid"
                >
                    <ProductsFilterCheckboxItem
                        :model-value="model[attrObj.uid!]!"
                        :attr-obj="attrObj"
                        @update:model-value="onChange(attrObj.uid!, $event)"
                    ></ProductsFilterCheckboxItem>
                </template>
            </ul>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ProductFilterAttribute,
        ProductFilterModelItem
    } from '~/types';
    import ProductsFilterTitle from '~/components/products/products-list/ProductsFilterTitle/ProductsFilterTitle.vue';
    import ProductsFilterCheckboxItem from '~/components/products/products-list/ProductsFilterCheckboxItem/ProductsFilterCheckboxItem.vue';
    import { pausableFilter, watchWithFilter } from '@vueuse/core';

    const {
        eventFilter,
        pause,
        resume
    } = pausableFilter();

    const props = defineProps<{
        modelValue: Nilish<ProductFilterModelItem>;
        items: Nilish<ProductFilterAttribute>;
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: ProductFilterModelItem];
    }>();

    const model = ref<Nilish<ProductFilterModelItem>>(props.modelValue);
    const selectedCount = computed<number>(() => {
        return !model.value ? 0 : Object.values(model.value).filter((v) => !!v).length;
    });

    const unWatchModelValue = watchWithFilter(
        () => props.modelValue,
        (updatedModel: Nilish<ProductFilterModelItem>) => {
            model.value = updatedModel;
        },
        {
            eventFilter,
            immediate: true
        }
    );

    function onChange(uid: string, value: boolean) {
        if (model.value) {
            model.value[uid] = !model.value[uid];
            pause();
            emit('update:modelValue', model.value);
            setTimeout(() => resume?.(), 250);
        }
    }

    onBeforeUnmount(() => {
        unWatchModelValue?.();
    });
</script>

<style lang="scss"></style>
